<template>
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">

            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search')"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="examResultsTable"
      :items="examResults"
      responsive
      :fields="fields"
      primary-key="id"
      show-empty
      :empty-text="$t('No matching records found')"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(apply_doc)="data">
        {{ data.value.full_name }}
      </template>

      <template #cell(dc_type)="data">
        {{ $langName(getDcType(data.value).name) }}
      </template>

      <template #cell(is_certificate)="data">
        <b-badge :variant="data.value ? 'success': 'danger'">
          {{ $t(data.value ? 'Yes': 'No') }}
        </b-badge>
      </template>

      <template #cell(is_accepted)="data">
        <b-badge :variant="getExamResultColor(data.value)">
          {{ $langName(getExamResultStatus(data.value).name) }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'applicant-document-view', params: { id: data.item.apply_doc.id }})"
          />
          <feather-icon
            v-if="canRemoveFile(exam)"
            icon="TrashIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="removeExamResult(data.item)"
          />
          <feather-icon
            v-if="canAddAsAdditional(exam, data.item)"
            icon="PlusSquareIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="addAsAdditional(data.item)"
          />
          <feather-icon
            v-if="canReAddAsAdditional(exam, data.item)"
            icon="TrashIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="removeFromAdditional(data.item)"
          />
        </div>
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label=""
          />
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BCol, BFormInput, BRow, BSpinner,
  BTable, BBadge,
} from 'bootstrap-vue'
import permission from '../permission'

export default {
  name: 'ResultExamListComponent',
  components: {
    BCard,
    BCol,
    BFormInput,
    BRow,
    BSpinner,
    BTable,
    BBadge,
  },
  props: {
    examResults: {
      required: true,
      type: Array,
    },
    isFirstQuarter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    exam() {
      return this.$store.state.exam.exam
    },
  },
  created() {
    if (!this.isFirstQuarter) {
      this.fields = [
        { key: 'index', label: '#' },
        { key: 'apply_doc', label: 'Applicant', sortable: true },
        { key: 'dc_type', label: 'Dc Type', sortable: true },
        { key: 'is_accepted', label: 'Status', sortable: true },
        { key: 'actions', label: '' },
      ]
    }
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getExamResultStatus(status) {
      return this.$store.getters['staticModule/getExamResultStatus'](status)
    },
    getExamResultColor(status) {
      return this.$store.getters['staticModule/getExamResultColor'](status)
    },
    removeExamResult(data) {
      this.$emit('removeExamResult', data)
    },
    addAsAdditional(data) {
      this.$emit('addAsAdditional', data)
    },
    removeFromAdditional(data) {
      this.$emit('removeFromAdditional', data)
    },
  },
  setup() {
    const searchQuery = ''
    const fields = [
      { key: 'index', label: '#' },
      { key: 'apply_doc', label: 'Applicant', sortable: true },
      { key: 'dc_type', label: 'Dc Type', sortable: true },
      { key: 'direction_mark', label: 'Direction mark', sortable: true },
      { key: 'is_certificate', label: 'Is certificate', sortable: true },
      { key: 'english_mark', label: 'English Mark', sortable: true },
      { key: 'is_accepted', label: 'Status', sortable: true },
      { key: 'actions', label: '' },
    ]
    return {
      searchQuery,
      fields,
      ...permission(),
    }
  },
}
</script>

<style scoped>

</style>
